import { getRTDates } from "app/pages/activation/components/RankWidget/helpers/getRTDates";
import type { KeywordTrendsCreationDTO, RankTrackerCampaign } from "app/pages/activation/types/api";
import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const prepareRequestKWTrendData = (data: RankTrackerCampaign): KeywordTrendsCreationDTO | null => {
    if (!data?.firstScrapeTime) {
        return null;
    }

    const { from, to } = getRTDates(data);

    const scrapingConfigurationGuids =
        data.scrapingConfigurations.find(({ device }) => device === DEVICES_TYPES_FOR_API.DESKTOP)?.id ??
        data.scrapingConfigurations[0].id;

    return {
        campaignguid: data.id,
        sites: data.site,
        to,
        from,
        scrapingConfigurationGuids,
        isDaily: true,
        granularity: "daily",
    };
};
